import { useReactiveVar } from '@apollo/client';
import { useContext } from 'react';

import AccountContext from 'context/AccountContext';
import FeatureFlagsContext from 'context/FeatureFlagsContext';
import { featureCountryCode } from 'states/persistInStorage';
import { isMobilePayEnabledForCountry } from 'utils/featureFlagUtils';

// Whether the "add MobilePay" option should be offered: FI customer, the
// per-country flag on, and no MobilePay wallet registered yet. Shared by the
// add-payment-method entry point (modal routing) and AddOtherPaymentMethod
// (row visibility) so the two gate identically.
const useCanAddMobilePay = (): boolean => {
  const {
    flags: { enable_mobilepay_by_country },
  } = useContext(FeatureFlagsContext);
  const appCountryCode = useReactiveVar(featureCountryCode);
  const {
    customer: {
      paymentOptions,
      countryCode: customerCountryCode,
      contactEmail,
    },
  } = useContext(AccountContext);

  const hasMobilePay = !!paymentOptions?.some(
    (option) => option?.method === 'MOBILEPAY'
  );

  return (
    customerCountryCode === 'FI' &&
    !hasMobilePay &&
    isMobilePayEnabledForCountry(
      enable_mobilepay_by_country,
      appCountryCode,
      contactEmail
    )
  );
};

export default useCanAddMobilePay;
